export default __webpack_public_path__ + "static/media/member3.6819eb8b.png";